import PropTypes from "prop-types";
import React from "react";

// Shared country dropdown for the cart's shipping estimate and the checkout billing form.
// A static list for now; the demo may later feed it from the Categories app.
export const COUNTRIES = [
    "Austria",
    "Belgium",
    "Canada",
    "Czech Republic",
    "Denmark",
    "Finland",
    "France",
    "Germany",
    "Ireland",
    "Italy",
    "Netherlands",
    "Norway",
    "Poland",
    "Portugal",
    "Spain",
    "Sweden",
    "Switzerland",
    "United Kingdom",
    "United States",
];

const CountrySelect = ({ className, name, placeholder = "Select a country" }) => (
    <select className={className} name={name} defaultValue="">
        <option value="">{placeholder}</option>
        {COUNTRIES.map((country) => (
            <option key={country} value={country}>
                {country}
            </option>
        ))}
    </select>
);

CountrySelect.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
};

export default CountrySelect;